import Vue from 'vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import {
    AmplifyPlugin
} from 'aws-amplify-vue'
//import awsmobile from '~/aws-exports'

let landing;

if (process.env.NODE_ENV === "development") {
    landing = 'http://localhost:8080/signin'
} else {
    landing = global.location.host.includes("mers") ? process.env.VUE_APP_MERS_REDIRECT_URL : process.env.VUE_APP_REDIRECT_URL;
}



const oauth = {
    // Domain name
    domain: process.env.VUE_APP_COGNITO_URL,

    // Authorized scopes
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],

    // Callback URL
    redirectSignIn: landing,

    // Sign out URL
    redirectSignOut: 'http://localhost:8080',

    // 'code' for Authorization code grant, 
    // 'token' for Implicit grant
    responseType: 'code',

    // optional, for Cognito hosted ui specified options
    options: {
        // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
        //AdvancedSecurityDataCollectionFlag: true
    }
}

Amplify.configure({
    oauth: oauth,
    //mandatorySignIn: false,
    userPoolId: process.env.VUE_APP_POOL_ID,
    userPoolWebClientId: global.location.host.includes("mers") ? process.env.VUE_APP_MERS_POOL_CLIENT_ID : process.env.VUE_APP_POOL_CLIENT_ID,
    identityPoolRegion: process.env.VUE_APP_AWS_REGION,
    authenticationFlowType: 'USER_SRP_AUTH',
    aws_appsync_graphqlEndpoint: process.env.VUE_APP_APPSYNC_API_URL,
    aws_appsync_region: process.env.VUE_APP_AWS_REGION,
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS'
})

Vue.use(AmplifyPlugin, AmplifyModules)